export default __webpack_public_path__ + "static/IBMPlexSans-LightItalic-68aaf61ee29338caa97db4827efee55c.woff2";